import {Component} from "@angular/core";
import {DialogService} from "../../bootstrap-modal/dialog.service";
import {DialogComponent} from "../../bootstrap-modal/dialog.component";
import {AddressModel} from "../../address/address.model";
import {FilteredList} from "../../helpers/filtered-list";

export type SiteDifferencesType = {tmcSite: AddressModel, k2Site: AddressModel};

export interface ShowSiteDiffDialogModel {
  siteDifferences: SiteDifferencesType[];
}

@Component({
  templateUrl: "./dialog-show-site-differences.template.pug",
  providers: [],
})
export class DialogShowSiteDifferencesComponent
  extends DialogComponent<ShowSiteDiffDialogModel, any> implements ShowSiteDiffDialogModel {
  filters: any;
  error: Error;
  siteDifferences: SiteDifferencesType[] = [];

  list: FilteredList<SiteDifferencesType> = new FilteredList<SiteDifferencesType>({startingPageSize: 1});

  static showSiteDifferencesDialogModal(dialogService: DialogService, inputs: ShowSiteDiffDialogModel): Promise<any> {
    return dialogService.showDialog(DialogShowSiteDifferencesComponent, inputs);
  }

  ready() {
    this.list.items = this.siteDifferences;
  }

  exit(): void {
    this.result = {success: true};
    this.close();
  }

  constructor(public dialogService: DialogService) {
    super(dialogService);
  }
}
